document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector("#header");
  if (header instanceof HTMLElement) {
    const headerHeight = header.offsetHeight;
    document.body.style.setProperty("--header-height", `${headerHeight}px`);
  }

  const DEFAULT_ALT = "{{ product.title | escape }}";

  // Observe DOM changes inside the zoom container
  const zoomContainers = document.querySelectorAll('.zoom-img-container');

  zoomContainers.forEach(container => {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.tagName === 'IMG') {
            // Add alt text when a new image is injected
            if (!node.hasAttribute('alt') || node.getAttribute('alt') === '') {
              node.setAttribute('alt', DEFAULT_ALT);
            }
          }
        });
      });
    });

    observer.observe(container, {
      childList: true,
      subtree: true
    });
  });
});
